import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    let timer: number;
    const load = () => {
      setLoadDeferredContent(true);
      window.removeEventListener('scroll', load);
      window.removeEventListener('mousemove', load);
      window.removeEventListener('touchstart', load);
      if (timer) window.clearTimeout(timer);
    };
    window.addEventListener('scroll', load, {
      passive: true
    });
    window.addEventListener('mousemove', load, {
      passive: true
    });
    window.addEventListener('touchstart', load, {
      passive: true
    });

    // Fallback timeout to ensure it loads eventually if no interaction
    timer = window.setTimeout(load, 3500);
    return () => {
      window.removeEventListener('scroll', load);
      window.removeEventListener('mousemove', load);
      window.removeEventListener('touchstart', load);
      if (timer) window.clearTimeout(timer);
    };
  }, []);
  return <div className="w-full bg-off-white text-slate" data-id="element-0" data-mp="2zld1r8m3ndb0">
      <MetaPixel data-id="element-1" data-mp="2zmwj72jhrued" />
      <StickyHeader data-id="element-2" data-mp="2zng0qi58cgrv" />
      <main data-id="element-3" data-mp="33mf1rrnubte1">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="33lwxq8uxsavk" />
        <Hero data-id="element-5" data-mp="33orjc3pos1qk" />
        <SocialProofBar data-id="element-6" data-mp="38lrnua6w0wfk" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-off-white" aria-hidden="true" data-id="element-8" data-mp="38nuqput52k1p" />} data-id="element-7" data-mp="38k6vmr81ppkv">
            <DeferredLanding data-id="element-9" data-mp="3dlnsmbnesrw6" />
          </Suspense>}
      </main>
    </div>;
}